import ligjiPunes from "../assets/Ligji i Punes.pdf"
import ligjiFestatZyrtare from "../assets/Ligji per Festat Zyrtare.pdf"
import LigjiperMbrojtjeneteDhenavePersonale from "../assets/Ligji per Mbrojtjen e te Dhenave Personale.pdf" 
import LigjiperMenaxhimineFinancavePublike from "../assets/Ligji per Menaxhimin e Financave Publike.pdf"
import LigjiperNdermarrjetPublike from "../assets/Ligji per Ndermarrjet Publike.pdf"
import LigjiperndryshimindheplotesimineligjitperNdermarrjetPublike1 from "../assets/Ligji per ndryshimin dhe plotesimin e ligjit per Ndermarrjet Publike 1.pdf"
import LigjiperndryshimindheplotesimineligjitperNdermarrjetPublike2 from "../assets/Ligji per ndryshimin dhe plotesimin e ligjit per Ndermarrjet Publike 2.pdf"
import LigjiperProcedurenePergjithshmeAdministrative from "../assets/Ligji per Proceduren e Pergjithshme Administrative.pdf"
import LigjiperShoqeriteTregtare from "../assets/Ligji per Shoqerite Tregtare.pdf"

const kornizaLigjore = [
    {
        id: 1,
        name: "Ligji i punës",
        src: ligjiPunes
    },
    {
        id: 2,
        name: "Ligji për Festat Zyrtare",
        src: ligjiFestatZyrtare
    },
    {
        id: 3,
        name: "Ligji për Mbrojtjen e të Dhënave Personale",
        src: LigjiperMbrojtjeneteDhenavePersonale
    },
    {
        id: 4,
        name: "Ligji për Menaxhimin e Financave Publike",
        src: LigjiperMenaxhimineFinancavePublike
    },
    {
        id: 5,
        name: "Ligji për Ndërmarrjet Publike",
        src: LigjiperNdermarrjetPublike
    },
    {
        id: 6,
        name: "Ligji për ndryshimin dhe plotësimin e ligjit për Ndërmarrjet Publike 1",
        src: LigjiperndryshimindheplotesimineligjitperNdermarrjetPublike1
    },
    {
        id: 7,
        name: "Ligji për ndryshimin dhe plotësimin e ligjit për Ndërmarrjet Publike 2",
        src: LigjiperndryshimindheplotesimineligjitperNdermarrjetPublike2
    },
    {
        id: 8,
        name: "Ligji për Proceduren e Përgjithshme Administrative",
        src: LigjiperProcedurenePergjithshmeAdministrative
    },
    {
        id: 9,
        name: "Ligji për Shoqërite Tregtare",
        src: LigjiperShoqeriteTregtare
    }
]

export { kornizaLigjore }